export const ACCESS_COST = 0.6;
